<mat-tab-group class="block-keywords" (selectChange)="tabChanged($event)">
    <mat-tab label="Events">
        <ng-template mat-tab-label>
            Events
        </ng-template>
        <div class="panel">
            <div class="panel-header">
                <h1>Block Keywords / Organizers / Venues
                    <mat-icon style="color:#41abf3"
                              matTooltip="{{blackType==='keyword'?'All events contains the keyword will not be shown':'All events created by the organizer will not be shown'}}">
                        info
                    </mat-icon>
                </h1>
            </div>
            <ig-row [alignMiddle]="true">
                <ig-col [xs]="6" [md]="4">
                    <ig-select [(ngModel)]="blackSourceItems" label="Type" (itemSelected)="typeSourceChange($event)">
                    </ig-select>
                </ig-col>
                <ig-col [xs]="6" [md]="4">
                    <ig-field label="Type keyword or Organizers / Venues" [isRequired]="true" [(ngModel)]="keywordText"
                              [formControl]="blockKeywordsFormGroup.get('blackValue')"></ig-field>
                </ig-col>
            </ig-row>
            <ig-button (trigger)="addBlockKeyword($event)" [isAsync]="true" [disabled]="blockKeywordsFormGroup.invalid"
                       size="md" style="width:120px">
                ADD
            </ig-button>
        </div>

        <div class="panel">
            <div class="panel-header">
                <h1>Blocked Keywords / Organizers / Venues</h1>
            </div>
            <ig-list>
                <div header *ngIf="blacklist.length">
                    <ig-list-column-header>
                        <div>Type</div>
                        <div>Value</div>
                        <div actions>
                            <div>Actions</div>
                        </div>
                    </ig-list-column-header>
                </div>
                <div body>
                    <ig-list-item *ngFor="let blackItem of blacklist">
                        <div>
                            {{ blackItem.blackType.replace('user', 'organizer') }}
                        </div>
                        <div>
                            {{ blackItem.blackValue }}
                        </div>
                        <ig-row-action-buttons>
                            <mat-icon matTooltip="Delete" (click)="deleteBlockKeyword(blackItem)">
                                clear
                            </mat-icon>
                        </ig-row-action-buttons>
                    </ig-list-item>
                    <div *ngIf="!blacklist||!blacklist.length" class="empty-list">
                        No Content Here...
                    </div>
                </div>
            </ig-list>
        </div>

        <div class="panel block-domain">
            <div class="panel-header">
                <h1>Block Event by Domain Name</h1>
                <mat-icon style="color:#41abf3"
                          matTooltip="Event will be filtered out if its link or ticket URL contains the domain name">
                    info
                </mat-icon>
            </div>
            <div>Type the domain name to block</div>
            <ig-multi-fields [group]="blockedEventDomains" [filterText]="['https://', 'http://']"
                             label="e.g., domainname.com"></ig-multi-fields>
            <ig-button (trigger)="updateBlockedEventDomains($event)" [isAsync]="true" size="md" style="width:120px">
                UPDATE
            </ig-button>
        </div>

        <div class="panel">
            <div class="panel-header">
                <h1>Removed Events</h1>
            </div>
            <ig-list>
                <div header *ngIf="blockEvents.length">
                    <ig-list-column-header>
                        <div style="flex: 2">Title</div>
                        <div>Owner</div>
                        <div>Start Time</div>
                        <div>Image</div>
                        <div actions>
                            <div>Actions</div>
                        </div>
                    </ig-list-column-header>
                </div>
                <div body>
                    <ig-list-item *ngFor="let event of blockEvents"
                                  [matTooltip]="event.isSimilarWithClientEvent?'Similar with your event':''"
                                  matTooltipPosition="left">
                        <div class="long-description" style="flex: 2">
                            {{ event.title || event.name }}
                        </div>
                        <div>
                            {{ event.owner ? event.owner.name : '(no owner)' }}
                        </div>
                        <div>
                            {{ event.startTimeFormatted || event.startTime }}
                        </div>
                        <div>
                            <img *ngIf="event.cover&&event.cover.source" class="block-image" height="50px"
                                 [src]="imageService.imageSource(event)"/>
                        </div>
                        <ig-row-action-buttons>
                            <mat-icon matTooltip="revert" (click)="revertBlockEvent(event)">
                                undo
                            </mat-icon>
                            <mat-icon matTooltip="delete" (click)="deleteEventPermanently(event)">
                                delete_forever
                            </mat-icon>
                        </ig-row-action-buttons>
                    </ig-list-item>
                    <div *ngIf="!blockEvents||!blockEvents.length" class="empty-list">
                        No Content Here...
                    </div>
                </div>
            </ig-list>
        </div>
    </mat-tab>

    <mat-tab label="Places">
        <ng-template mat-tab-label>
            Places
        </ng-template>

        <div class="panel">
            <div class="panel-header">
                <h1>Block Google place keywords</h1>
            </div>
            <div class="text-left light-gray-text">Type the keywords you want to block for places here</div>
            <ig-multi-fields [group]="clientPlaceBlockKeywords" label="keywords"></ig-multi-fields>
            <ig-button size="md" (trigger)="blockPlaceKeywords($event)" style="width:160px">
                save
            </ig-button>
        </div>

        <div class="panel ig-global-place-blocked">
            <div class="panel-header">
                <h1>Blocked Places by Keywords</h1>
                <p>These places are blocked by the keywords you set above</p>
            </div>
            <ig-list>
                <div header *ngIf="blockByClientKeywordsPlaces.length">
                    <ig-list-column-header>
                        <div style="flex: 2">Title</div>
                        <div style="flex: 2">Address</div>
                        <div>Image</div>
                    </ig-list-column-header>
                </div>
                <div body>
                    <ig-list-item *ngFor="let place of blockByClientKeywordsPlaces">
                        <div class="long-description" style="flex: 2">
                            {{ place.name }}
                        </div>
                        <div class="long-description" style="flex: 2">
                            {{ place.address }}
                        </div>
                        <div>
                            <img *ngIf="place.cover&&place.cover.source" class="block-image" height="50px"
                                 [src]="imageService.imageSource(place)"/>
                        </div>
                    </ig-list-item>
                    <div *ngIf="!blockByClientKeywordsPlaces||!blockByClientKeywordsPlaces.length" class="empty-list">
                        No Content Here...
                    </div>
                </div>
            </ig-list>
        </div>

        <div class="panel">
            <div class="panel-header">
                <h1>Manually Removed Places</h1>
            </div>
            <ig-list>
                <div header *ngIf="blockPlaces.length">
                    <ig-list-column-header>
                        <div style="flex: 2">Title</div>
                        <div style="flex: 2">Address</div>
                        <div>Image</div>
                        <div actions>
                            <div>Actions</div>
                        </div>
                    </ig-list-column-header>
                </div>
                <div body>
                    <ig-list-item *ngFor="let place of blockPlaces">
                        <div class="long-description" style="flex: 2">
                            {{ place.title || place.name }}
                        </div>
                        <div class="long-description" style="flex: 2">
                            {{ place.address }}
                        </div>
                        <div>
                            <img *ngIf="place.cover&&place.cover.source" class="block-image" height="50px"
                                 [src]="imageService.imageSource(place)"/>
                        </div>
                        <ig-row-action-buttons>
                            <mat-icon matTooltip="revert" (click)="revertBlockPlace(place)">
                                undo
                            </mat-icon>
                            <mat-icon matTooltip="delete" (click)="deletePlacePermanently(place)">
                                delete_forever
                            </mat-icon>
                        </ig-row-action-buttons>
                    </ig-list-item>
                    <div *ngIf="!blockPlaces||!blockPlaces.length" class="empty-list">
                        No Content Here...
                    </div>
                </div>
            </ig-list>
        </div>
        <div class="panel ig-global-place-blocked">
            <div class="panel-header">
                <h1>Blocked Places by Global Keywords</h1>
                <p>These places are blocked by global settings, please contact ImGoing administrator if you have any
                    questions
                </p>
            </div>
            <ig-list>
                <div header *ngIf="blockPlaces.length">
                    <ig-list-column-header>
                        <div style="flex: 2">Title</div>
                        <div style="flex: 2">Address</div>
                        <div>Image</div>
                        <!-- <div actions>
                            <div>Actions</div>
                        </div> -->
                    </ig-list-column-header>
                </div>
                <div body>
                    <ig-list-item *ngFor="let place of blockByGlobalKeywordsPlaces">
                        <div class="long-description" style="flex: 2">
                            {{ place.title || place.name }}
                        </div>
                        <div class="long-description" style="flex: 2">
                            {{ place.address }}
                        </div>
                        <div>
                            <img *ngIf="place.cover&&place.cover.source" class="block-image" height="50px"
                                 [src]="imageService.imageSource(place)"/>
                        </div>
                        <!-- <ig-row-action-buttons>
                            <mat-icon matTooltip="revert" (click)="revertBlockPlace(place)">
                                undo
                            </mat-icon>
                        </ig-row-action-buttons> -->
                    </ig-list-item>
                    <div *ngIf="!blockByGlobalKeywordsPlaces||!blockByGlobalKeywordsPlaces.length" class="empty-list">
                        No Content Here...
                    </div>
                </div>
            </ig-list>
        </div>
    </mat-tab>
</mat-tab-group>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/block.keywords/block.keywords.component.html